// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPendContributionsForCipPropertyDto
 */
export interface IPendContributionsForCipPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IPendContributionsForCipPropertyDto
     */
    pend_contributions_for_cip?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPendContributionsForCipPropertyDto
     */
    pend_contributions_for_cip_state?: IPendContributionsForCipPropertyDtoPendContributionsForCipStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPendContributionsForCipPropertyDtoPendContributionsForCipStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IPendContributionsForCipPropertyDto interface.
 */
export function instanceOfIPendContributionsForCipPropertyDto(value: object): value is IPendContributionsForCipPropertyDto {
    return true;
}

export function IPendContributionsForCipPropertyDtoFromJSON(json: any): IPendContributionsForCipPropertyDto {
    return IPendContributionsForCipPropertyDtoFromJSONTyped(json, false);
}

export function IPendContributionsForCipPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPendContributionsForCipPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pend_contributions_for_cip': json['pend_contributions_for_cip'] == null ? undefined : json['pend_contributions_for_cip'],
        'pend_contributions_for_cip_state': json['pend_contributions_for_cip_state'] == null ? undefined : json['pend_contributions_for_cip_state'],
    };
}

export function IPendContributionsForCipPropertyDtoToJSON(json: any): IPendContributionsForCipPropertyDto {
    return IPendContributionsForCipPropertyDtoToJSONTyped(json, false);
}

export function IPendContributionsForCipPropertyDtoToJSONTyped(value?: IPendContributionsForCipPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pend_contributions_for_cip': value['pend_contributions_for_cip'],
        'pend_contributions_for_cip_state': value['pend_contributions_for_cip_state'],
    };
}

